import { render } from "./ClienteContactoTab.vue?vue&type=template&id=e5ebd48c"
import script from "./ClienteContactoTab.vue?vue&type=script&lang=js"
export * from "./ClienteContactoTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__